import { createStore } from "vuex";
import Cookies from "js-cookie";

// import main from "../main";

// Helper function to retrieve blurb by name
function getBlurbByName(state, name) {
  const blurb = state.blurbs[name];
  if (blurb) {
    return blurb;
  } else if (state.socket.socket) {
    // Queue the Blurb if not already queued
    if (!state.socket.blurbQueue.includes(name)) {
      store.commit("pushBlurbQueue", name);
    }
  }
  return "Loading..."; // or any other default value you want
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return "";
}

async function getCsrfToken() {
  await fetch("/api/auth/csrf/", {
    method: "GET",
    credentials: "same-origin",
  });
  return getCookie("csrftoken");
}

const store = createStore({
  state: {
    messages: [],
    socket: {
      socket: null,
      // Connection Status
      isConnected: false,
      // Reconnect error
      reconnectError: false,
      reconnectAttempt: 0,
      reconnectTimer: null,
      // Heartbeat message sending time
      heartBeatInterval: 50000,
      // Heartbeat timer
      heartBeatTimer: 0,
      blurbQueue: [],
      blurbQueueTimer: null,
      blurbQueueInterval: 500,
    },
    auth: {
      is_auth: false,
      username: "",
    },
    teams: {
      selectedTeam: null,
      defaultTeamId: null,
      all: {
        1: {
          name: "",
          time_sheep: 0,
          time_alpaca: 0,
          time_llama: 0,
          time_setup: 0,
          time_setup_many_sheep: 0,
          many_sheep_thres: 0,
          time_teardown: 0,
          time_extra_driving: 0,
          begin_time: "07:00:00",
          max_day_time: 0,
        },
      },
    },
    filters: {
      fromDate: Cookies.get("fromDate") || null,
      toDate: Cookies.get("toDate") || null,
      selectedRegistrationType: "scheduled",
      seasonId: 1,
      selectedRegistrations: [],
      selectedSeason: null,
      searchStr: "",
    },
    blurbs: {},
    registrations: {
      displayRegistration: {
        scheduled_start: "1970-01-01T00:00:00",
      },
      registrations: [],
      route: [],
      hasFetchedRegistrations: false,
    },
    seasons: {},
    defaultSeasonId: null,
  },
  getters: {
    getBlurbByName: (state) => (name) => getBlurbByName(state, name),
    registrationRequestData: (state) => {
      return {
        type: state.filters.selectedRegistrationType,
        team: state.teams.selectedTeam || state.teams.defaultTeamId,
        season: state.filters.selectedSeason,
        from_date: state.filters.fromDate,
        to_date: state.filters.toDate,
      };
    },
  },
  mutations: {
    // Connection open
    addMessage(state, message) {
      state.messages.push(message);
    },
    setBlurbTexts(state, blurbs) {
      state.blurbs = blurbs;
    },
    pushBlurbQueue(state, name) {
      state.socket.blurbQueue.push(name);
    },
    setSelectedTeam(state, newValue) {
      state.teams.selectedTeam = newValue;
    },
    updateFilters(state, filters) {
      state.filters.fromDate = filters.fromDate;
      state.filters.toDate = filters.toDate;
      state.filters.selectedRegistrationType = filters.selectedRegistrationType;
      state.filters.selectedSeason = filters.selectedSeason;
    },
    updateSearchStr(state, searchStr) {
      state.filters.searchStr = searchStr;
    },
    updateSelectedRegistrations(state, registrations) {
      state.filters.selectedRegistrations = registrations;
    },
    setAuthState(state, { is_auth, username }) {
      state.auth.is_auth = !!is_auth;
      state.auth.username = username || "";
    },
    SOCKET_ONOPEN(state, event) {
      state.socket.socket = event.currentTarget;
      state.socket.isConnected = true;
      state.socket.reconnectError = false;
      state.socket.reconnectAttempt = 0;
      clearTimeout(state.socket.reconnectTimer);
      // When the connection is successful, start sending heartbeat messages regularly to avoid being disconnected by the server
      state.socket.heartBeatTimer = setInterval(() => {
        const message = "Heartbeat message";
        state.socket.isConnected &&
          state.socket.socket.send(
            JSON.stringify({
              jsonrpc: "2.0",
              method: "heartbeat",
              params: { message: message },
            })
          );
      }, state.socket.heartBeatInterval);

      // Start the Blurb Queue timer
      state.socket.blurbQueueTimer = setInterval(() => {
        if (state.socket.blurbQueue.length > 0) {
          while (state.socket.blurbQueue.length > 0) {
            const item = state.socket.blurbQueue.pop();
            const method = "sendJSONrpcMessage";
            const params = { method: "request_blurb", params: { name: item } };
            store.dispatch(method, params);
          }
        }
      }, state.socket.blurbQueueInterval);

      // Get all existing blurbs from server
      store.dispatch("sendJSONrpcMessage", {
        method: "request_all_blurbs",
        params: {},
      });

      // Get Authentication info from server
      store.dispatch("sendJSONrpcMessage", {
        method: "request_auth_info",
        params: {},
      });

      // Get global config info from server
      // Get all existing blurbs from server
      store.dispatch("sendJSONrpcMessage", {
        method: "request_global_config",
        params: {},
      });
    },
    // Connection closed
    SOCKET_ONCLOSE(state, event) {
      state.socket.isConnected = false;
      // Stop the heartbeat message when the connection is closed
      clearInterval(state.socket.heartBeatTimer);
      state.socket.heartBeatTimer = 0;
      clearTimeout(state.socket.reconnectTimer);
      const delay =
        Math.min(30000, 500 * 2 ** state.socket.reconnectAttempt++) +
        Math.floor(Math.random() * 300);
      state.socket.reconnectTimer = setTimeout(() => {
        window.__altitudeReconnectWs?.();
      }, delay);
      console.log("The line is disconnected: " + new Date());
      console.log(event);
    },
    // An error occurred
    SOCKET_ONERROR(state, event) {
      console.error(state, event);
    },
    // Receive the message sent by the server
    SOCKET_ONMESSAGE(state, message) {
      console.log(message.data);
      var data = {};
      try {
        data = JSON.parse(message.data);
      } catch {
        console.log("Invalid JSON");
        return;
      }
      if (data.method == "return_all_blurbs") {
        this.dispatch("updateBlurbTexts", data.result.blurbs);
      }
      if (data.method == "return_auth_info") {
        state.auth.username = data.result.username;
        state.auth.is_auth = data.result.is_authenticated;
      }
      // Handle return_registration_data response
      if (data.method == "return_registration_data") {
        const registrations = data.result.registrations;
        state.registrations.registrations = registrations;
        state.registrations.route = data.result.route;
        state.registrations.hasFetchedRegistrations = true;
        console.log(data);
        if ("change_type" in data.result) {
          state.filters.selectedRegistrationType = data.result.change_type;
        }
      }
      if (data.method == "return_registration_info") {
        const displayRegistration = data.result.registration;
        state.registrations.displayRegistration = displayRegistration;
      }
      if (data.method == "return_team_data") {
        state.teams.all = data.result.all;
        state.teams.defaultTeamId =
          data.result.default_team_id !== null &&
          typeof data.result.default_team_id !== "undefined"
            ? String(data.result.default_team_id)
            : null;
        const hasSelectedTeam =
          state.teams.selectedTeam &&
          Object.prototype.hasOwnProperty.call(
            state.teams.all,
            state.teams.selectedTeam
          );
        if (!hasSelectedTeam) {
          state.teams.selectedTeam =
            state.teams.defaultTeamId ||
            Object.keys(state.teams.all || {})[0] ||
            null;
        }
      }
      if (data.method == "return_global_config") {
        state.seasons = data.result.seasons;
        state.defaultSeasonId = data.result.default_season_id;
        if (!state.filters.selectedSeason && state.defaultSeasonId) {
          state.filters.selectedSeason = state.defaultSeasonId;
        }
      }
    },
    // Auto reconnect
    SOCKET_RECONNECT(state, count) {
      console.info("Message system reconnecting...", state, count);
    },
    // Reconnect error
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    },
  },
  actions: {
    cancelRegistrations(context) {
      const params = { ...context.getters.registrationRequestData };
      params.ids = context.state.filters.selectedRegistrations;
      context.dispatch("sendJSONrpcMessage", {
        method: "cancel_registrations",
        params: params,
      });
    },
    fetchRegistrationInfo(context, uuid) {
      context.dispatch("sendJSONrpcMessage", {
        method: "get_registration_info",
        params: {
          uuid: uuid,
        },
      });
    },
    fetchRegistrations(context) {
      context.dispatch("sendJSONrpcMessage", {
        method: "get_registration_data",
        params: context.getters.registrationRequestData,
      });
    },
    mailRegistrations(context, { name, registration_id }) {
      const params = { ...context.getters.registrationRequestData };
      params.name = name;
      if (typeof registration_id !== "undefined") {
        params.ids = [registration_id];
      } else {
        params.ids = context.state.filters.selectedRegistrations;
      }
      context.dispatch("sendJSONrpcMessage", {
        method: "mail_registrations",
        params: params,
      });
    },
    moveRegistrationDay(context, delta) {
      const params = { ...context.getters.registrationRequestData };
      params.ids = context.state.filters.selectedRegistrations;
      params.delta = delta;
      context.dispatch("sendJSONrpcMessage", {
        method: "move_registration_day",
        params: params,
      });
    },
    moveRegistrationOrder(context, delta) {
      const params = { ...context.getters.registrationRequestData };
      params.id = context.state.filters.selectedRegistrations[0];
      params.delta = delta;
      context.dispatch("sendJSONrpcMessage", {
        method: "move_registration_order",
        params: params,
      });
    },
    sendJSONrpcMessage({ state }, { method, params }) {
      const socket = state.socket.socket;
      if (socket) {
        socket.send(
          JSON.stringify({
            jsonrpc: "2.0",
            id: 1,
            method: method,
            params: params,
          })
        );
      }
    },
    setDateTime(context, { date, time }) {
      const params = { ...context.getters.registrationRequestData };
      params.ids = context.state.filters.selectedRegistrations;
      params.set_date = date;
      params.set_time = time;
      context.dispatch("sendJSONrpcMessage", {
        method: "set_datetime",
        params: params,
      });
    },
    uncancelRegistrations(context) {
      const params = { ...context.getters.registrationRequestData };
      params.ids = context.state.filters.selectedRegistrations;
      context.dispatch("sendJSONrpcMessage", {
        method: "uncancel_registrations",
        params: params,
      });
    },
    unscheduleRegistrations(context) {
      const params = { ...context.getters.registrationRequestData };
      params.ids = context.state.filters.selectedRegistrations;
      context.dispatch("sendJSONrpcMessage", {
        method: "unschedule_registrations",
        params: params,
      });
    },
    updateBlurbTexts({ commit }, blurbs) {
      commit("setBlurbTexts", blurbs);
    },
    saveBlurbByName(context, { name, value }) {
      const params = {
        name: name,
        value: value,
      };

      // Assuming you have a "sendJSONrpcMessage" action defined in your store
      return context.dispatch("sendJSONrpcMessage", {
        method: "save_blurb",
        params,
      });
    },
    async sendLogin({ commit }, { username, password }) {
      try {
        const csrfToken = await getCsrfToken();
        const response = await fetch("/api/auth/login/", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify({ username, password }),
        });
        if (!response.ok) {
          commit("setAuthState", { is_auth: false, username: "" });
          return false;
        }
        const data = await response.json();
        commit("setAuthState", {
          is_auth: data.is_authenticated,
          username: data.username,
        });
        window.__altitudeReconnectWs?.();
        return true;
      } catch (error) {
        console.error("Login request failed", error);
        commit("setAuthState", { is_auth: false, username: "" });
        return false;
      }
    },
    async sendLogout({ commit }) {
      try {
        const csrfToken = await getCsrfToken();
        const response = await fetch("/api/auth/logout/", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "X-CSRFToken": csrfToken,
          },
        });
        if (!response.ok) {
          return false;
        }
        commit("setAuthState", { is_auth: false, username: "" });
        window.__altitudeReconnectWs?.();
        return true;
      } catch (error) {
        console.error("Logout request failed", error);
        return false;
      }
    },
    requestBlurb({ commit }, name) {
      commit("pushBlurbQueue", name);
    },
    fetchTeamData(context) {
      context.dispatch("sendJSONrpcMessage", {
        method: "get_team_data",
        params: {},
      });
    },
    sendTeamUpdate(context, teamData) {
      context.dispatch("sendJSONrpcMessage", {
        method: "update_team",
        params: { team_data: teamData },
      });
    },
    addTeam(context, name) {
      context.dispatch("sendJSONrpcMessage", {
        method: "add_team",
        params: { name: name },
      });
    },
    autoSchedule(context, { fromDate, fromTime, includeScheduled, toDate }) {
      const params = { ...context.getters.registrationRequestData };
      params.ids = context.state.filters.selectedRegistrations;
      params.fromDate = fromDate;
      params.fromTime = fromTime;
      params.includeScheduled = includeScheduled;
      params.toDate = toDate;
      context.dispatch("sendJSONrpcMessage", {
        method: "auto_schedule",
        params: params,
      });
    },
  },
  modules: {},
});

export default store;
